import { TariffEntity } from 'backend-entity';

export type CrmCreateTariffRequestDto = Omit<Partial<TariffEntity>, 'id' | 'createdAt' | 'updatedAt' | 'durationDays'> &
  Pick<TariffEntity, 'ident' | 'name' | 'duration' | 'durationUnit' | 'durationType' | 'currency'>;
